/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

export function AdminOnlineStoreAdd() {
  const history = useHistory();
  const [savingFile, setSavingFile] = useState<File>();
  const [siteUrlText, setSiteUrlText] = useState('http://www.');
  const [nameText, setNameText] = useState('');
  const [fileUrl, setFileUrl] = useState('');
  const dispatch = useDispatch();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  // 온라인 서점 등록하기
  const onClickSave = async () => {
    if (savingFile === undefined || savingFile === null) {
      dispatch(toast.error({ message: '등록할 서점 이미지를 업로드해주세요.' }));
      return;
    }
    const savedData = await server
      .postOnlineStore({
        name: nameText,
        urlOnline: siteUrlText,
      })
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          dispatch(toast.info({ message: '정상적으로 저장되었습니다.' }));
        }
        history.push('/admin/store/online');
        return payload;
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });

    if (savedData !== undefined) {
      const savedDataId = savedData.id;
      if (savingFile !== undefined) {
        await server
          .patchOnlineStoreattache(savedDataId, { image: savingFile })
          .then(() => {
            history.push('/admin/store/online');
          })
          .catch((error) => {
            dispatch(toast.error({ message: '첨부파일 에러 ' }));
            return error;
          });
      }
    }
  };

  return (
    <main className="images wrapper">
      <div className="title">
        <h1>온라인 서점 등록하기</h1>
        <div className="buttons">
          <button type="button" onClick={() => onClickSave()}>
            등록
          </button>
        </div>
      </div>
      <div className="content">
        <ul className="inputs">
          <li>
            <span className="required">등록할 서점 이미지</span>
            <div className="input-file-container">
              <input
                className="input-file"
                id="file02"
                type="file"
                onChange={(e) => {
                  if (
                    e.target !== null &&
                    e.target.files !== null &&
                    e.target.files[0] !== undefined
                  ) {
                    setSavingFile(e.target.files[0]);
                    const preview = e.target.files[0];
                    const imageUrl = URL.createObjectURL(preview);
                    setFileUrl(imageUrl);
                  }
                }}
              />
              <label tabIndex={0} htmlFor="file02" className="input-file-trigger">
                파일 선택
              </label>
            </div>
            <img
              src={fileUrl}
              alt={savingFile?.name}
              onLoad={() => {
                dispatch(toast.info({ message: '이미지 업로드 완료.' }));
                window.URL.revokeObjectURL(fileUrl);
              }}
            />
            <small>※ 사이즈: 180x66 (픽셀)</small>
          </li>
          <li>
            <span>연결 URL</span>
            <input
              className="full"
              type="url"
              defaultValue={siteUrlText}
              onChange={(e) => {
                setSiteUrlText(e.target.value);
              }}
            />
          </li>
          <li>
            <span>서점명</span>
            <input
              type="text"
              id="name"
              value={nameText}
              onChange={(e) => {
                setNameText(e.target.value);
              }}
            />
          </li>
        </ul>
      </div>
    </main>
  );
}
